import React from 'react';

import { createRoot } from 'react-dom/client';

import '../../style-sheet-helpers-migrated.css';
import '../../index-global.less';
import * as Cookies from '../../constants/cookies';
import { CookieService } from '../../services/cookie-service';
import { LogService } from '../../services/log-service';
import './login.css';
import { AuthPageProvider } from '../auth-page-provider';
import { LoginForm } from './login-form';
import { IDPLoginPage } from '../idp-login';
import { setupAxios } from '../../setup-axios';
import { isValidMarketplace, saveMarketplaceRedirect } from './marketplace-redirect-service';
import { removeLoadCover } from '../../global/remove-load-cover';

setupAxios({ isNativeAuth: true });

const RenderLoginForm = () => {
  const params = new URL(document.location).searchParams;

  // Fallback: set marketplace redirect cookie client-side for local dev / native login environments.
  // In deployed Auth0 environments, this cookie is set server-side in ss-ui-node before the Auth0 redirect.
  const marketplace = params.get('marketplace');
  if (isValidMarketplace(marketplace)) {
    saveMarketplaceRedirect(marketplace, params);
  }

  const successfullyVerified = params.get('verified') === 'true';
  const sessionExpired = params.get('sessionExpired') === 'true';
  const isRedirectedFromMarketingSignup = params.get('firsttime') === 'true';
  const redirect = params.get('redirect');

  const showLoggedOutForMaintenance = CookieService.getCookieValue(Cookies.NeedsLoggedOutForMaintMsg);
  const customErrorMsg = CookieService.getCookieValue(Cookies.AuthErrorOrLogoutMsg);
  if (showLoggedOutForMaintenance) {
    CookieService.removeCookie(Cookies.NeedsLoggedOutForMaintMsg);
  } else if (customErrorMsg) {
    CookieService.removeCookie(Cookies.AuthErrorOrLogoutMsg);
  }

  const LoginPage =
    window.location.pathname === '/idp/login' ? (
      <IDPLoginPage />
    ) : (
      <LoginForm
        customErrorMsg={customErrorMsg}
        isRedirectedFromMarketingSignup={isRedirectedFromMarketingSignup}
        marketplace={marketplace}
        redirect={redirect}
        sessionExpired={sessionExpired}
        shouldRenderRememberMe
        showLoggedOutForMaintenance={showLoggedOutForMaintenance}
        successfullyVerified={successfullyVerified}
      />
    );

  return <AuthPageProvider>{LoginPage}</AuthPageProvider>;
};

const isModernBrowser = __SUPPORTED_BROWSERS_REGEXP__.test(navigator.userAgent);
if (!isModernBrowser) {
  try {
    const browserWarning = document.getElementById('browser-warning');
    browserWarning.style.display = 'block';
    if (window.analytics) {
      window.analytics.track('browserWarning unsupportedBrowser', { userAgent: navigator.userAgent });
    }
  } catch (e) {
    LogService.logError(e);
  }
}

removeLoadCover();

// we should render the login form regardless
const root = createRoot(document.getElementById('login-form-wrapper'));
root.render(<RenderLoginForm />);
